import { Link } from "react-router-dom";
import { isAgentPortal } from "js/utilities";
import { phoneNumberFormatting } from "js/formatting";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { useTranslation, Trans } from "react-i18next";

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  useBreadcrumb([
    {
      name: "Home",
      url: `${isAgentPortal() ? "/dashboard" : "/policies"}`,
    },
    { name: "Privacy Notice", url: "#" },
  ]);
  return (
    <>
      <div className="container ui-component-spacing">
        <h1>{t("PrivacyPolicy-title")}</h1>
        <hr />
      </div>

      <div className="container ui-component-spacing font-body">
        <p className="mb-6">{t("PrivacyPolicy-effective-date")}</p>
        <p>{t("PrivacyPolicy-point-1")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-2")}</p>

        <br />

        <p>
          <Trans
            i18nKey="PrivacyPolicy-point-3"
            components={{
              link1: <Link to="/california-consumer-privacy-statement"></Link>,
            }}
          ></Trans>
        </p>

        <br />

        <h2>{t("PrivacyPolicy-subTitle-1")}</h2>
        <p>{t("PrivacyPolicy-point-4")}</p>

        <br />

        <ul className="list-disc list-outside pl-5">
          <li>{t("PrivacyPolicy-listItem-1")}</li>
          <li>{t("PrivacyPolicy-listItem-2")}</li>
          <li>{t("PrivacyPolicy-listItem-3")}</li>
          <li>{t("PrivacyPolicy-listItem-4")}</li>
          <li>{t("PrivacyPolicy-listItem-5")}</li>
        </ul>

        <br />

        <p>{t("PrivacyPolicy-point-5")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-6")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-7")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-8")}</p>

        <br />

        <h2>{t("PrivacyPolicy-subTitle-2")}</h2>
        <p>{t("PrivacyPolicy-point-9")}</p>
        <ul className="list-disc list-outside pl-5">
          <li>{t("PrivacyPolicy-listItem-6")}</li>
          <li>{t("PrivacyPolicy-listItem-7")}</li>
          <li>{t("PrivacyPolicy-listItem-8")}</li>
          <li>{t("PrivacyPolicy-listItem-9")}</li>
          <li>{t("PrivacyPolicy-listItem-10")}</li>
          <li>{t("PrivacyPolicy-listItem-11")}</li>
          <li>{t("PrivacyPolicy-listItem-12")}</li>
          <li>{t("PrivacyPolicy-listItem-13")}</li>
          <li>{t("PrivacyPolicy-listItem-14")}</li>
          <li>{t("PrivacyPolicy-listItem-15")}</li>
          <li>{t("PrivacyPolicy-listItem-16")}</li>
          <li>
            <Trans
              i18nKey="PrivacyPolicy-listItem-17"
              components={{
                link1: <Link to="/terms-of-use"></Link>,
              }}
            ></Trans>
          </li>
        </ul>
        <br />

        <p>{t("PrivacyPolicy-point-10")}</p>
        <br />
        <p>
          <i>{t("PrivacyPolicy-point-11")}</i>
        </p>

        <p>
          <Trans
            i18nKey="PrivacyPolicy-point-12"
            components={{
              link1: (
                <a
                  href="https://www.google.com/policies/privacy/partners"
                  target="__blank"
                ></a>
              ),
            }}
          ></Trans>
        </p>

        <br />

        <h2>{t("PrivacyPolicy-subTitle-3")}</h2>
        <p>{t("PrivacyPolicy-point-13")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-14")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-15")}</p>

        <br />

        <h2>{t("PrivacyPolicy-subTitle-4")}</h2>
        <p>
          <Trans
            i18nKey="PrivacyPolicy-point-16"
            components={{
              link1: <a href="#howtocontactus"></a>,
            }}
          ></Trans>
        </p>

        <br />

        <h2>{t("PrivacyPolicy-subTitle-5")}</h2>
        <p>{t("PrivacyPolicy-point-17")}</p>

        <br />

        <h2>{t("PrivacyPolicy-subTitle-6")}</h2>
        <p>
          <Trans
            i18nKey="PrivacyPolicy-point-18"
            components={{
              link1: <a href="#howtocontactus"></a>,
            }}
          ></Trans>
        </p>

        <br />

        <h2>{t("PrivacyPolicy-subTitle-7")}</h2>
        <p>{t("PrivacyPolicy-point-19")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-20")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-21")}</p>

        <br />

        <p>{t("PrivacyPolicy-address-line-1")}</p>
        <p>{t("PrivacyPolicy-address-line-2")}</p>
        <p>{t("PrivacyPolicy-address-line-3")}</p>

        <br />

        <p>
          <Trans
            i18nKey="PrivacyPolicy-address-line-4"
            values={{ phoneNumber: phoneNumberFormatting("8888858912") }}
            components={{
              link1: (
                <a href="tel:+1-888-885-8912">
                  {phoneNumberFormatting("8888858912")}
                </a>
              ),
            }}
          ></Trans>
        </p>

        <p>{t("PrivacyPolicy-point-22")}</p>

        <br />

        <p>{t("PrivacyPolicy-subTitle-8")}</p>

        <br />

        <p>
          <Trans
            i18nKey="PrivacyPolicy-point-23"
            values={{ phoneNumber: phoneNumberFormatting("8778636338") }}
            components={{
              link1: (
                <a href="tel:+1-877-863-6338">
                  {phoneNumberFormatting("8778636338")}
                </a>
              ),
            }}
          ></Trans>
        </p>
        <p>
          <Trans
            i18nKey="PrivacyPolicy-point-24"
            values={{ phoneNumber: phoneNumberFormatting("8778636339") }}
            components={{
              link1: (
                <a href="tel:+1-877-863-6339">
                  {phoneNumberFormatting("8778636339")}
                </a>
              ),
            }}
          ></Trans>
        </p>

        <br />

        <h2>{t("PrivacyPolicy-subTitle-9")}</h2>
        <p>{t("PrivacyPolicy-point-25")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-26")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-27")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-28")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-29")}</p>

        <p>{t("PrivacyPolicy-point-30")}</p>

        <br />

        <p>{t("PrivacyPolicy-address-line-1")}</p>
        <p>{t("PrivacyPolicy-address-line-2")}</p>
        <p>{t("PrivacyPolicy-address-line-3")}</p>

        <br />

        <p>
          <Trans
            i18nKey="PrivacyPolicy-address-line-4"
            values={{ phoneNumber: phoneNumberFormatting("8888858912") }}
            components={{
              link1: (
                <a href="tel:+1-888-885-8912">
                  {phoneNumberFormatting("8888858912")}
                </a>
              ),
            }}
          ></Trans>
        </p>

        <br />

        <p>{t("PrivacyPolicy-point-31")}</p>

        <br />

        <p>{t("PrivacyPolicy-subTitle-8")}</p>

        <br />

        <p>{t("PrivacyPolicy-point-32")}</p>
        <p>
          <Trans
            i18nKey="PrivacyPolicy-point-33"
            components={{
              link1: (
                <a
                  href="tel:1-800-942-6906"
                  className="text-black no-underline"
                ></a>
              ),
            }}
          ></Trans>
        </p>
        <p>
          <Trans
            i18nKey="PrivacyPolicy-point-34"
            components={{
              link1: (
                <a
                  href="tel:1-800-942-6908"
                  className="text-black no-underline"
                ></a>
              ),
            }}
          ></Trans>
        </p>
        <p>
          <Trans
            i18nKey="PrivacyPolicy-point-35"
            components={{
              link1: (
                <a
                  href="tel:1-800-621-4673"
                  className="text-black no-underline"
                ></a>
              ),
            }}
          ></Trans>
        </p>
        <p>
          <Trans
            i18nKey="PrivacyPolicy-point-36"
            components={{
              link1: (
                <a
                  href="tel:1-866-604-5350"
                  className="text-black no-underline"
                ></a>
              ),
            }}
          ></Trans>
        </p>

        <br />

        <h2>{t("PrivacyPolicy-subTitle-10")}</h2>
        <p>{t("PrivacyPolicy-point-37")}</p>

        <br />

        <h2>{t("PrivacyPolicy-subTitle-11")}</h2>
        <p>{t("PrivacyPolicy-point-38")}</p>

        <br />

        <h2 id="howtocontactus">{t("PrivacyPolicy-subTitle-12")}</h2>
        <p>
          <Trans
            i18nKey="PrivacyPolicy-point-39"
            components={{
              link1: <a href="mailto:info@everlakelife.com"></a>,
              link2: <a href="tel:+1-888-885-8912"></a>,
            }}
          ></Trans>
        </p>
      </div>
    </>
  );
}
